// Material from a FEN, in pawns (Q9 R5 B3 N3 P1): what a line is measured by
// when the scan carries no score per ply. Moved from review-puzzles' finder
// (2026-10-14), read by the puzzles and by the step controls' main line.
import type { Color, Fen, PieceType } from '@chess/api-model';

const VALUE: Record<PieceType, number> = { p: 1, n: 3, b: 3, r: 5, q: 9, k: 0 };

/** Material of a side from a FEN's board field. */
export function material(fen: Fen, side: Color): number {
  let total = 0;
  for (const ch of fen.split(' ')[0]) {
    const lower = ch.toLowerCase() as PieceType;
    if (!(lower in VALUE)) continue;
    const isWhite = ch === ch.toUpperCase();
    if ((side === 'white') === isWhite) total += VALUE[lower];
  }
  return total;
}

/** A side's material lead in pawns from a FEN's board field: its own count less the other side's. */
export function balance(fen: Fen, side: Color): number {
  return material(fen, side) - material(fen, side === 'white' ? 'black' : 'white');
}
